export default __webpack_public_path__ + "static/media/Thumbtack.ed5b6c29.svg";